import { View } from '@components/layout'
import { renderSvg } from './renderSvg'

export const Icon = ({ name, size = 20, color = 'black', ...props }) => (
  <View {...props}>{renderSvg(name, size, color)}</View>
)
